window.document.ready(() => {
  const subscribeBox = document.getElementById('subscribe-to-newsletter'),
    messageBox = subscribeBox?.closest('div').querySelector('.message');

  if (subscribeBox) {
    subscribeBox.addEventListener('change', (e) => {
      fetch('/api/Newsletter/Subscriber/Status', {
        method: 'POST',
        body: JSON.stringify(e.target.checked),
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then((response) => response.json())
        .then((data) => {
          messageBox.innerText = data.message;
        });
    });

    fetch('/api/Newsletter/Subscriber/Status')
      .then((response) => response.json())
      .then((data) => {
        subscribeBox.checked = data.subscribed;
        messageBox.innerText = data.message;
      });
  }
});
